import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField, AvFeedback } from 'availity-reactstrap-validation';
import './profile.scss';
import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT, ERROR, Resources, SUCCESS } from 'app/config/constants';
import { constants } from 'os';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
export interface IModalUpdateProps extends StateProps, DispatchProps {
  display: boolean;
  handleClose: Function;
  attribute: any;
  verifyResidentailFail: boolean;
}

var dob = '';

export interface IModalUpdateState {
  message: string;
}
export class ModalUpdateAttribute extends React.Component<IModalUpdateProps, IModalUpdateState> {
  state: IModalUpdateState = {
    message: ''
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.resUpdateAttr !== nextProps.resUpdateAttr) {
      const { resUpdateAttr } = nextProps;
      if (resUpdateAttr.status === SUCCESS && resUpdateAttr.dataSources === 'CSDL Quốc gia về Dân cư') {
        let identity = resUpdateAttr.infoValid.filter(item => item.name === 'identity');
        let citizen = resUpdateAttr.infoValid.filter(item => item.name === 'citizenId');
        if (identity.length == 0) {
          this.setState({ message: 'Thông tin CMT cập nhật không thành công do trùng với tài khoản trên hệ thống' });
        } else if (citizen.length == 0) {
          this.setState({ message: 'Thông tin CCCD cập nhật không thành công do trùng với tài khoản trên hệ thống' });
        } else {
          this.setState({ message: '' });
        }
      }
    }
  }

  renderValue = item => {
    if (item.name == 'dateOfBirth' && !item.value.includes('/')) {
      dob = item.value ? moment(item.value).format(APP_LOCAL_DATE_FORMAT) : '';
    }
    switch (item.name) {
      case 'dateOfBirth':
        return (
          <AvForm>
            <AvField name={item.name} value={dob != '' ? dob : item.value} type="text" readOnly />
          </AvForm>
        );
      case 'gender':
        return (
          <AvForm>
            <AvField name={item.name} value={item.value == '1' ? 'Nam' : 'Nữ'} type="text" readOnly />
          </AvForm>
        );
      case 'identityVerified':
      case 'citizenIdVerified':
        return null;
      default:
        return (
          <AvForm>
            <AvField name={item.name} value={item.value} type="text" readOnly />
          </AvForm>
        );
    }
  };
  bindingDatalabel = item => {
    switch (item.name) {
      case 'identityVerified':
      case 'citizenIdVerified':
        return null;
      default:
        return <label>{item.label}</label>;
    }
  };
  bindingImage = item => {
    switch (item.name) {
      case 'identityVerified':
      case 'citizenIdVerified':
        return null;
      default:
        return <img src={require('../../../images/ic_tick.png')} alt="" />;
    }
  };
  bindingDataResidential = () => {
    return this.props.attribute && this.props.attribute.infoValid && this.props.attribute.infoValid.length > 0
      ? this.props.attribute.infoValid.filter(
          item =>
            item.name == 'cn' ||
            item.name == 'identity' ||
            item.name == 'citizenId' ||
            item.name == 'dateOfBirth' ||
            item.name == 'gender' ||
            item.name == 'birthPlace' ||
            item.name == 'originLocal' ||
            item.name == 'permanentAddress'
        )
      : [];
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.display}
          centered={window.location === window.parent.location}
          size="lg"
          backdrop="static"
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '80%' }}
        >
          <ModalHeader toggle={this.props.handleClose} />
          <ModalBody>
            <div>
              <div>
                {this.props.attribute == null ? null : this.props.attribute &&
                  this.props.attribute.dataSources == 'CSDL Quốc gia về Dân cư' &&
                  this.props.attribute.status == ERROR ? null : this.props.attribute &&
                  this.props.attribute.infoInValid &&
                  this.props.attribute.infoInValid.length > 0 ? null : (
                  <div className="row" style={{ margin: '10px 0px 20px 10px' }}>
                    <img src={require('../../../images/ic_tick.png')} alt="" />
                    <label style={{ marginLeft: '5px' }}>Cập nhật thành công các thông tin</label>
                  </div>
                )}
                {this.props.attribute && this.props.attribute.infoInValid && this.props.attribute.infoInValid.length > 0 ? null : this.props
                    .attribute &&
                  this.props.attribute.infoValid &&
                  this.props.attribute.infoValid.length > 0 ? (
                  this.props.attribute.dataSources == 'CSDL Quốc gia về Dân cư' ? (
                    <div>
                      <div>
                        {this.bindingDataResidential().map((item, index) => (
                          <div className="row" style={{ margin: '0px 10px' }}>
                            <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                              <label>{item.label}</label>
                            </div>
                            <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>{this.renderValue(item)}</div>
                            <div className={window.innerWidth < 768 ? 'col-2' : 'col-sm-3'}>
                              <img src={require('../../../images/ic_tick.png')} alt="" />
                            </div>
                          </div>
                        ))}
                      </div>
                      <div>
                        <label style={{ color: '#4D9235', fontStyle: 'italic', marginTop: '20px' }}>{this.state.message}</label>
                      </div>
                    </div>
                  ) : (
                    this.props.attribute.infoValid.map((item, index) => (
                      <div className="row" style={{ margin: '0px 10px' }}>
                        <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>{this.bindingDatalabel(item)}</div>
                        <div className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>{this.renderValue(item)}</div>
                        <div className={window.innerWidth < 768 ? 'col-2' : 'col-sm-3'}>{this.bindingImage(item)}</div>
                      </div>
                    ))
                  )
                ) : null}
              </div>
              {/* <hr /> */}
              <div>
                {this.props.attribute == null ? null : (this.props.attribute &&
                    this.props.attribute.infoInValid &&
                    this.props.attribute.infoInValid.length > 0) ||
                  (this.props.attribute &&
                    this.props.attribute.dataSources == 'CSDL Quốc gia về Dân cư' &&
                    this.props.attribute.status == ERROR) ? (
                  <div className="row" style={{ margin: '10px 0px 20px 10px' }}>
                    <div className="col-xs-1 col-sm-1">
                      <img src={require('../../../images/ic_clear.png')} alt="" />
                    </div>
                    <div className="col-xs-11 col-sm-11">
                      <label style={{ marginLeft: '5px' }}>
                        {this.props.verifyResidentailFail
                          ? 'Các thông tin cập nhật thất bại do thông tin không khớp với thông tin tại CSDL Dân cư, vui lòng kiểm tra lại thông tin đã nhập hoặc liên hệ với Công an nơi cư trú để cập nhật dữ liệu dân cư!'
                          : 'Các thông tin cập nhật thất bại do không khớp thông tin'}
                      </label>
                    </div>
                  </div>
                ) : null}
                {this.props.attribute && this.props.attribute.infoInValid && this.props.attribute.infoInValid.length > 0
                  ? this.props.attribute.infoInValid.map((item, index) => (
                      <div className="row" style={{ margin: '0px 10px' }}>
                        <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
                          {item.name === 'identityVerified' || item.name === 'citizenIdVerified' ? null : <label>{item.label}</label>}
                        </div>
                        <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-6'}>{this.renderValue(item)}</div>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: 'none' }}>
            <Button
              className="btn-register"
              style={{ marginLeft: 'auto', marginRight: 'auto', width: '160px' }}
              onClick={this.props.handleClose}
            >
              Đóng
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userProfile: storeState.userInfo.userProfile,
  resUpdateAttr: storeState.userInfo.resUpdateAttr
});
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalUpdateAttribute);
